import AsyncStorage from '@react-native-async-storage/async-storage';

export type PublicPreviewFeature =
  | 'color_analysis'
  | 'virtual_drape'
  | 'color_generator';

const STORAGE_KEYS: Record<PublicPreviewFeature, string> = {
  color_analysis: 'coloursense_public_preview_used_color_analysis',
  virtual_drape: 'coloursense_public_preview_used_virtual_drape',
  color_generator: 'coloursense_public_preview_used_color_generator',
};

export async function getPublicPreviewUsed(
  feature: PublicPreviewFeature
): Promise<boolean> {
  try {
    const value = await AsyncStorage.getItem(STORAGE_KEYS[feature]);
    return value === 'true';
  } catch {
    return false;
  }
}

export async function setPublicPreviewUsed(
  feature: PublicPreviewFeature
): Promise<void> {
  try {
    await AsyncStorage.setItem(STORAGE_KEYS[feature], 'true');
  } catch {
    // Non-fatal
  }
}
